<template>
    <div class="order-coupon">
<!--add new coupon-->
        <div v-if="!isOpen" class="coupon-add">
            <span class="coupon-add__title">{{ promo.title }}</span>
            <button
                type="button"
                class="coupon-add__button"
                @click.prevent="isOpen = true"
            >
                <svg><use xlink:href="#svg-plus"></use></svg>
                <span>{{ promo.show }}</span>
            </button>
        </div>
<!--input new coupon-->
        <div v-else class="coupon-apply">
            <div class="coupon-apply__header">
                <span class="coupon-apply__title">{{ promo.title }}</span>
                <button
                    type="button"
                    @click.prevent="handlerRemoveCoupon"
                    class="coupon-apply__hide"
                >
                    {{ promo.hide }}
                </button>
            </div>
            <label class="coupon-apply__label">
                <span
                    class="coupon-apply__placeholder"
                    :class="{ 'coupon-apply__placeholder_active': coupon.length > 0 || inputFocus }"
                >{{ promo.placeholder }}</span>
                <input
                    type="text"
                    name="COUPON"
                    class="coupon-apply__input"
                    :class="{
                                'coupon-apply__input_error': isError,
                                'coupon-apply__input_success': isSuccess,
                            }"
                    v-model="coupon"
                    @keyup.enter="$emit('setAjax')"
                    @focus="inputFocus = true"
                    @blur="inputFocus = false"
                    @input="handlerInput"

                >
                <input
                    type="hidden"
                    name="CLICK_SET_COUPON"
                    id="click-set-coupon"
                    value=""
                >

                <svg v-if="isError"><use xlink:href="#svg-promo-error"></use></svg>
                <svg v-if="isSuccess"><use xlink:href="#svg-promo-success"></use></svg>
            </label>
            <button
                type="submit"
                @click="checkCouponUsed()"
                @click.prevent="$emit('setAjax')"
                class="coupon-apply__button"
                :class="{ 'coupon-apply__button_disabled': coupon.length === 0 }"
                v-if="!promoResult || coupon.length === 0"
            >
                {{ promo.btn_title }}
            </button>
            <!--error message-->
            <span
                v-else-if="promoResult.TYPE === 'error'"
                class="coupon-apply__message coupon-apply__message_error"
            >
                <svg><use xlink:href="#svg-promo-error"></use></svg>
                <span>{{ promoResult.text }}</span>
            </span>
            <!--success message-->
            <span
                v-else-if="promoResult.TYPE === 'success'"
                class="coupon-apply__message coupon-apply__message_success"
            >
                <svg><use xlink:href="#svg-promo-success"></use></svg>
                <span>{{ promoResult.text }}</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'order-coupon',
    props: {
        result: {
            type: Object,
            default: () => {}
        },
        jsData: {
            type: Object,
        }
    },
    data() {
        return {
            isOpen: false,
            coupon: '',
            inputFocus: false,
        }
    },
    computed: {
        promo() {

            return this.result?.messages?.promo;
        },
        promoResult() {
            return this.jsData?.PROMO_RESULT;
        },
        isError() {
            return this.jsData?.PROMO_RESULT?.TYPE === 'error'
        },
        isSuccess() {
            return this.jsData?.PROMO_RESULT?.TYPE === 'success'
        },
    },
    methods: {
        handlerInput() {
            if (this.isError || this.isSuccess) {
                this.jsData.PROMO_RESULT = false;
                //this.$emit('setAjax');
            }
        },
        handlerRemoveCoupon() {
            this.isOpen = false;
            this.coupon = '';
            this.$nextTick(() => {
               this.$emit('setAjax');
            })

        },
        checkCouponUsed() {
            $('#click-set-coupon').attr('value', 'Y');
        }
    },
    mounted() {
        console.log(this.jsData?.PROMO_RESULT?.TYPE);
        if(typeof this.jsData?.COUPON_LIST === 'object') {
            for (var key in this.jsData.COUPON_LIST) {
                if(this.jsData.COUPON_LIST[key].COUPON) {
                    this.coupon = this.jsData.COUPON_LIST[key].COUPON.COUPON;
                    this.isOpen = true;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.order-coupon{

}
.coupon-add{
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__title{
        font-size: rem(16);
        line-height: 125%;
        font-weight: 500;
    }
    &__button{
        display: flex;
        align-items: center;
        background-color: transparent;
        line-height: 100%;
        svg{
            display: block;
            width: 14px;
            height: 14px;
            margin-right: 8px;
        }
        span{
            text-decoration: underline;
            text-underline-position: under;
        }
    }
}
.coupon-apply{
    &__header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 40px;
    }
    &__title{
        font-size: rem(16);
        line-height: 125%;
        font-weight: 500;
    }
    &__hide{
        background-color: transparent;
        text-decoration: underline;
        text-underline-position: under;
    }
    &__label{
        display: block;
        position: relative;
        svg{
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 16px;
            height: 16px;
        }
    }
    &__placeholder{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-weight: 500;
        font-size: rem(16);
        line-height: 100%;
        color: #5F5F67;
        transition: .3s linear top,
                    .3s linear translateY,
                    .3s linear font-size;
        &_active{
            top: 0%;
            transform: translateY(0);
            font-size: rem(10);
        }
    }
    &__input{
        display: flex;
        border: none;
        border-bottom: 1px solid #5F5F67;
        padding: 10px 0;
        width: 100%;
        margin-bottom: 24px;
        &_error{
            border-bottom-color: #E20712;
        }
        &_success{
            border-bottom-color: #689575;
        }
    }
    &__button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        background-color: black;
        height: 48px;
        border: 1px solid black;
        color: #fff;
        &_disabled{
            pointer-events: none;
            background-color: transparent;
            border-color: #CACECE;
            color: var(--text-colour-primary);
        }
    }
    &__message{
        display: flex;
        align-items: center;
        height: 40px;
        background: #F7EFEF;
        color: #E20712;
        padding: 0 16px;
        cursor: pointer;
        svg{
            display: block;
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }
        span{
            transform: translateY(2px);
        }
        &_error{
            color: #E20712;
            background: #F7EFEF;
        }
        &_success{
            color: #689575;
            background: #E4EEE7;
        }
    }

    //&__error{
    //    display: flex;
    //    align-items: center;
    //    height: 40px;
    //    background: #F7EFEF;
    //    color: #E20712;
    //    padding: 0 16px;
    //    cursor: pointer;
    //    svg{
    //        display: block;
    //        width: 16px;
    //        height: 16px;
    //        margin-right: 8px;
    //    }
    //    span{
    //        transform: translateY(2px);
    //    }
    //}
    //&__success{
    //    display: flex;
    //    align-items: center;
    //    background: #E4EEE7;
    //    height: 40px;
    //    padding: 0 16px;
    //    font-weight: 500;
    //    font-size: rem(14);
    //    line-height: 125%;
    //    color: #689575;
    //    svg{
    //        display: block;
    //        width: 16px;
    //        height: 16px;
    //        margin-right: 8px;
    //    }
    //    span{
    //        transform: translateY(2px);
    //    }
    //}
}
</style>